<template>
  <div :class="['sort-box', size, className]" @click="toggle">
    <div class="label one-txt-cut">{{ label }}</div>
    <slot name="icon">
      <div :class="['icon', sortStatus ? 'right' : 'left']">
        <img
          v-if="size === 'small'"
          src="@/assets/refund/icon_paixu@2x.png"
          alt=""
          srcset=""
        />
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "SorthBox",
  props: {
    className: {
      type: String,
      default: "", // large, small, mini
    },
    size: {
      type: String,
      default: "small", // large, small, mini
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sortStatus: false,
    };
  },
  methods: {
    toggle(){
      this.sortStatus = !this.sortStatus
      this.$emit('input', this.sortStatus)
      this.$emit('onchange', this.sortStatus)
    },
  },
};
</script>

<style lang="less" scoped>
.sort-box {
  display: flex;
  //   justify-content: center;
  align-items: center;

  .right {
    transform: rotateX(180deg);
  }
}

.large {
  .label {
    height: 20px;
    font-family: PingFangSC-Medium;
    font-weight: Medium;
    font-size: 20px;
    color: #171a1d;
    letter-spacing: 0;
    text-align: right;
    line-height: 20px;
    filter: blur(10);
  }
  .icon {
    margin-left: 3px;
    width: 10px;
    height: 6px;
  }
}

.small {
  .label {
    width: 84px;
    // height: 12px;
    font-family: PingFangSC-Regular;
    font-weight: Regular;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    text-align: right;
    // line-height: 12px;
    filter: blur(10);
  }
  .icon {
    margin-left: 5px;
    width: 12px;
    height: 12px;
  }
}
</style>
